/** Shared form styles for Challenge Wire modals (Tailwind v2 + project dark tokens). */

/** 16px minimum avoids iOS Safari auto-zoom on focus (same as header player search). */
const challengeWireFieldTextClass = 'text-base text-gray-900 dark:text-dark-text';

export const inputClass =
	`w-full min-w-0 max-w-full box-border rounded-xl border border-gray-300 dark:border-dark-border bg-white dark:bg-dark-bg px-3 py-2 ${challengeWireFieldTextClass}`;

const scheduleFieldBaseClass =
	`box-border rounded-xl border border-gray-300 dark:border-dark-border bg-white dark:bg-dark-bg px-3 py-2.5 ${challengeWireFieldTextClass}`;

/** Schedule panel: roomier spacing, controls sized to content (not full bleed). */
export const schedulePanelClass =
	'min-w-0 overflow-hidden rounded-xl border border-gray-200 dark:border-dark-border bg-gray-50 dark:bg-dark-bg p-4 sm:p-5 space-y-6';

export const scheduleBlockClass = 'space-y-3';

export const scheduleDividerClass = 'border-t border-gray-200 dark:border-dark-border pt-6 space-y-3';

export const scheduleSelectClass = `${scheduleFieldBaseClass} mt-2.5 block w-full max-w-xs`;

export const fieldLabelClass = 'font-medium text-gray-700 dark:text-gray-300';

/** Full-width label above schedule date pickers (matches Log Weight modal). */
export const scheduleDateFieldLabelClass =
	'block w-full text-sm font-medium text-gray-700 dark:text-dark-text-secondary';

export const hintClass = 'text-xs text-gray-500 dark:text-gray-400';

/** Multiday completion nudge. Tailwind v2: use yellow-* (not amber-*); bg-opacity, not slash opacity. */
export const challengeDayTrackingBlockedClass =
	'rounded-lg border border-yellow-200 bg-yellow-50 px-3 py-2 text-xs font-medium text-yellow-800 dark:border-yellow-800 dark:bg-yellow-900 dark:bg-opacity-25 dark:text-yellow-200';

export const sectionLabelClass =
	'text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400';

export const accentSectionLabelClass =
	'text-xs font-semibold uppercase tracking-wide text-blue-800 dark:text-blue-300';

/** Nested panel on modal card (schedule, preview). */
export const nestedPanelClass =
	'min-w-0 overflow-hidden rounded-xl border border-gray-200 dark:border-dark-border bg-gray-50 dark:bg-dark-bg p-3 sm:p-4 space-y-3';

/** Template options / accent blocks. */
export const accentPanelClass =
	'rounded-xl border border-blue-100 dark:border-blue-800 bg-blue-50 dark:bg-dark-bg p-4 space-y-3';

export const suggestionChipClass =
	'shrink-0 max-w-[200px] rounded-xl border border-blue-200 dark:border-blue-800 bg-blue-50 dark:bg-dark-bg px-3 py-2 text-left text-sm text-gray-900 dark:text-dark-text hover:border-blue-400 dark:hover:border-blue-600 transition';

export const suggestionChipTitleClass = 'font-semibold text-gray-900 dark:text-dark-text';

export const suggestionChipReasonClass = 'text-xs text-gray-600 dark:text-gray-400 mt-1';

export const templatePillInactiveClass =
	'border-gray-300 dark:border-dark-border bg-white dark:bg-dark-bg text-gray-700 dark:text-gray-300 hover:border-blue-400 dark:hover:border-blue-600';

export const quickDateButtonClass =
	'rounded-full border border-gray-300 dark:border-dark-border bg-white dark:bg-dark-card px-3 py-1 text-xs font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-dark-bg transition';

export const schedulePillActiveClass =
	'border-blue-600 bg-blue-600 text-white dark:border-blue-500 dark:bg-blue-600';

export const schedulePillInactiveClass = templatePillInactiveClass;

export const scheduleQuestionClass = 'text-sm font-medium text-gray-900 dark:text-dark-text';

/** Challenge Wire page: Friends / Household tabs, section headings. */
export const segmentInactiveClass =
	'text-gray-600 dark:text-gray-200 hover:text-gray-900 dark:hover:text-dark-text';

export const pageSectionHeadingClass =
	'text-sm font-semibold uppercase tracking-wide text-gray-700 dark:text-gray-200';

export const pageMutedTextClass = 'text-sm text-gray-600 dark:text-gray-400';

/** Send-challenge confirmation preview and challenge wire cards (content surface). */
export const challengeSummarySurfaceClass = 'bg-white dark:bg-dark-card';

/** Challenge card / summary footer (action bar). */
export const challengeSummaryFooterClass =
	'border-t border-gray-100 dark:border-dark-border bg-gray-50 dark:bg-black';

/** Send-challenge confirmation preview (nested inside the modal card). */
export const challengeSummaryPanelClass =
	'min-w-0 rounded-xl border border-gray-200 dark:border-dark-border bg-white dark:bg-dark-bg p-4 sm:p-5 space-y-3';
